import { render, staticRenderFns } from "./AboutYou.vue?vue&type=template&id=70381128&scoped=true&"
import script from "./AboutYou.vue?vue&type=script&lang=js&"
export * from "./AboutYou.vue?vue&type=script&lang=js&"
import style0 from "./AboutYou.vue?vue&type=style&index=0&id=70381128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70381128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDatePicker,VMenu,VSelect,VTextField})
